import { styled } from 'styled-components';
import { WrapperRound } from '~/components/ui/wrapper-round';
import bg from '@assets/images/icon/trophee.png';
import text from '@assets/images/background/trophee-v.svg';
import iconWatning from '@assets/images/icon/icon-warning.svg';
import point from '@assets/images/icon/exclamation-point.svg';
import { Dispatch, SetStateAction } from 'react';

type IProps = {
  onChallengeClick?: () => void;
  hasNotifications?: boolean;
  setNotifications?: Dispatch<SetStateAction<boolean>> | undefined;
  onChallengeClickWithNotifications?: () => void;
  isNotifications?: boolean;
};

type TProps = IProps;

export function ChallengesItem({
  onChallengeClick,
  hasNotifications,
  isNotifications,
  onChallengeClickWithNotifications,
}: TProps) {
  function handleChallengesClick() {
    onChallengeClick && onChallengeClick();
  }

  function handleChallengesWithNotificationClick() {
    onChallengeClickWithNotifications && onChallengeClickWithNotifications();
  }

  return (
    <WrapperRound
      onClick={
        isNotifications
          ? handleChallengesWithNotificationClick
          : handleChallengesClick
      }
    >
      <SImgBgWRBg src={bg} alt="" />
      <SImgBgWR src={bg} alt="" />
      <SDivImgText>
        <SImgText src={text} alt="" />
      </SDivImgText>
      {hasNotifications && (
        <SDivNotif>
          <SIconNotification src={iconWatning} alt="" />
          <SPoint src={point} alt="" />
        </SDivNotif>
      )}
    </WrapperRound>
  );
}

const SImgBgWRBg = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  object-fit: contain;
  height: 50%;
  width: 50%;
  transform: translate(-10%, -45%) rotate(20deg);
  pointer-events: none;
`;

const SImgBgWR = styled.img`
  position: absolute;
  left: 50%;
  top: 45%;
  object-fit: contain;
  height: 75%;
  width: 75%;
  transform: translate(-50%, -50%) rotate(-20deg);
  pointer-events: none;
`;

const SDivImgText = styled.div`
  position: absolute;
  left: 0;
  bottom: 2px;
  height: 53%;
  width: 70%;
`;

const SImgText = styled.img`
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  object-fit: contain;
  position: absolute;
  pointer-events: none;
`;

const SIconNotification = styled.img`
  position: absolute;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  object-fit: contain;
  pointer-events: none;
`;
const SPoint = styled.img`
  position: absolute;
  left: 50%;
  top: 35%;
  height: 50%;
  width: 50%;
  object-fit: contain;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

const SDivNotif = styled.div`
  position: absolute;
  height: 34px;
  width: 34px;
  top: -10%;
  right: -15%;
  pointer-events: none;

  @media screen and (max-height: 800px) {
    height: 30px;
    width: 30px;
  }
  @media screen and (max-height: 450px) {
    height: 20px;
    width: 20px;
  }

  @media screen and (max-width: 450px) {
    height: 20px;
    width: 20px;
  }
`;
